import { Injectable } from '@angular/core';
import { WindowService } from '@cigna/shared/angular/core/window-util';
import { fromEvent } from 'rxjs';

/**
 * Provides browser `localStorage` as a service. (While this doesn't strictly
 * *need* to be a service, it's a service so that tests can inject a mock
 * replacement.)
 */
@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  hasLocalStorage = this._window.localStorage != null;
  constructor(private _window: WindowService) {}

  storageUpdate$ = fromEvent(this._window, 'storage');

  get(key: string): string | null {
    if (!this.hasLocalStorage) {
      return null;
    }
    return this._window.localStorage.getItem(key);
  }

  put(key: string, value: string) {
    if (!this.hasLocalStorage) {
      return;
    }
    this._window.localStorage.setItem(key, value);
  }

  delete(key: string) {
    if (!this.hasLocalStorage) {
      return;
    }
    this._window.localStorage.removeItem(key);
  }
}
